var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selectable
    ? _c(
        "yxt-radio-group",
        {
          attrs: { direction: "row", disabled: _vm.disabled },
          model: {
            value: _vm.type,
            callback: function ($$v) {
              _vm.type = $$v
            },
            expression: "type",
          },
        },
        [
          _c("yxt-radio", { attrs: { label: 0 } }, [
            _vm._v(
              _vm._s(_vm.$t("pc_kng_lbl_downtype_sourcefile" /** 下载源文件 */))
            ),
          ]),
          _c("yxt-radio", { attrs: { label: 1 } }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "pc_kng_lbl_downtype_withwatermark" /** 下载带水印文件 */
                )
              )
            ),
          ]),
        ],
        1
      )
    : _c("div", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "pc_kng_lbl_downtype_privateUpload_desc" /** 学员下载的文件为源文件 */
            )
          )
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }